import styled from 'styled-components'

export const PageTitle = styled.h1`
  margin: 0;
  padding: 0 10px 10px 10px;
  font-size: 30px;
  font-weight: 600;
`
